import React, { FunctionComponent, useEffect, useState } from "react";

import useAmpolServiceDataStore from "../use-ampol-service-data-store";

import Map from "./map/map";
import Page from "./page/page";

const App: FunctionComponent<AppProps> = ({ ampolServiceDataUri }) => {
  const [hasGeolocated, setHasGeolocated] = useState(false);

  const fetchServices = useAmpolServiceDataStore(
    (store) => store.fetchServices
  );
  const loading = useAmpolServiceDataStore((store) => store.loading);
  const error = useAmpolServiceDataStore((store) => store.error);

  // Initialise the ampol data
  useEffect(() => {
    fetchServices(ampolServiceDataUri);
  }, [fetchServices, ampolServiceDataUri]);

  if (loading === true) {
    return <p>Loading...</p>;
  }
  if (error != null) {
    return <p>Error: {error}</p>;
  }

  return (
    <div
      id="app"
      className="tw-@container/main tw-w-full tw-min-h-max tw-flex tw-relative"
    >
      <Map disableInteractions={hasGeolocated === false} />
      <Page hasGeolocated={hasGeolocated} setHasGeolocated={setHasGeolocated} />
    </div>
  );
};

export type AppProps = {
  ampolServiceDataUri: string;
};

export default React.memo(App);
